import { ITypedReduxAction } from './actionType';
import { IGetArticlesListResponse } from '../../repositories/valuation-b2b/v1/get-articles-list';
import { IGetArticleResponse } from '../../repositories/valuation-b2b/v1/get-article';
import { actionTypes } from '../../constants/actionTypes';

const {
  GET_PUBLICATIONS_LIST_REQUEST: REQUEST,
  GET_PUBLICATIONS_LIST_SUCCESS: SUCCESS,
  GET_PUBLICATIONS_LIST_FAILURE: FAILURE,
} = actionTypes;

type requestAction = ITypedReduxAction<typeof REQUEST, void>;
type successAction = ITypedReduxAction<typeof SUCCESS, IGetArticlesListResponse>;
type failureAction = ITypedReduxAction<typeof FAILURE, void>;

export type TGetPublicationsListActions = requestAction | successAction | failureAction;

export interface IPublications {
  isFetching?: boolean;
  isError: boolean;
  data: IGetArticlesListResponse['data'] | null;
  articles: { [key: number]: IGetArticleResponse };
}
